import { Component } from '@angular/core';

@Component({
  selector: 'app-tab-qa-history',
  templateUrl: './tab-qa-history.component.html',
  styleUrls: ['./tab-qa-history.component.scss']
})
export class TabQaHistoryComponent {}
